/*
 * Shamone = Side sliding nav
 * http://www.youtube.com/watch?v=MSVqLUkvkzo

 * Shamone works with either a single button for nav on one side, or can be called
 * on two different buttons to expose nav on both the left and right sides.
 * Initially finds the nav element to be shown and moves it outside of the sliding content panel
 * (so that in responsive design, nav can be located anywhere and gets moved to proper place)

 * This should be called on the button that opens the nav:
 * <a href="#hidden-nav-panel-to-show" class="shamone">Hee hee!</a>
 * $('.shamone').shamone({ 'slideDirection': 'left' });
 * OR Override on per-element basis (good if there are two navs on left/right)
 * <a href="#nav" class="shamone" data-shamone-options='{ "slideDirection" : "right" }'>Note the inverted single/double quotes</a>
 * $('.shamone').shamone();

 * NOTE: SLIDE DIRECTION is required! No default is set for this value and the plugin
 * won't work without it!
 *
 */

;
define('core/ef_plugins/shamone',["jquery"], function(jQuery) {
    (function($, window, document, undefined) {
        console.log('shamone');
        var pluginName = 'shamone',
            defaults = {
                navSelector: "", // REQUIRED: selector for the navigation element
                contentPanelSelector: "", // REQUIRED: selector for the sliding panel
                slideDirection: "", // REQUIRED: which way the overlaying CONTENT panel should slide to reveal the nav beneath.

                buttonClass: "shamone-button", // Optional: class to apply to the button that starts the slide
                navClass: "shamone-nav", // Optional: class to apply to the nav element
                contentPanelClass: "shamone-content", // Optional: class to apply to the selected content panel
                activeButtonClass: "shamone-is-active-button", // Optional: class to apply to the active button
                activeNavSectionClass: "shamone-is-active-navsection", // Optional: class to apply to the active nav section
                openContentPanelClass: "shamone-is-open", // Optional: class to apply to the open content panel
                animateSlideClass: "shamone-is-animated", // Optional: class to apply to animate the content panel slide
                classPrefix: "shamone-is-", // Optional: class prefix (used to apply directional classes)

                linksDisabledElement: "", // Optional: DOM element that will have links disabled (off by default)
                openCallback: function() {}, // Optional: callback for when panel is opened
                closeCallback: function () { }, // Optional: callback for when panel is closed (by clicking button, not by selecting item in nav)
                setupCallback: function () { },
                destroyCallback: function () { },
            };

        // The actual plugin constructor
        function Shamone(element, options) {
            // grab the element the plugin was called on - this is the button that you click to open the side nav
            this.element = element;
            this.$element = $(element);

            // get per-element inline configuration settings
            this.metadata = this.$element.data('shamone-options');
            this.options = $.extend({}, defaults, options, this.metadata);

            // save the plugin name
            this._name = pluginName;

            // make sure slide direction is lowercase
            this.options.slideDirection = this.options.slideDirection.toLowerCase();

            // make sure that a slideDirection was passed in
            if (this.options.slideDirection !== "left" && this.options.slideDirection !== "right") {
                throw new Error("You must set a slideDirection. Exiting Shamone. Hee hee!");
                return;
            }

            // call init function
            this.init();
        }

        // Define this sucker
        Shamone.prototype = {
            init: function() {
                var plugin = this;

                // setup elements
                plugin.$element.addClass(plugin.options.buttonClass + " " + plugin.options.animateSlideClass);
                plugin.$nav = $(plugin.options.navSelector).addClass(plugin.options.navClass + " " + plugin.options.animateSlideClass);
                plugin.$contentPanel = $(plugin.options.contentPanelSelector).addClass(plugin.options.contentPanelClass + " " + plugin.options.animateSlideClass);
                plugin.$target = $(plugin.$element.attr('href'));
                plugin.isOpen = false;

                // take the nav element from wherever it is and put it outside of the content panel
                plugin._moveNav();

                // setup listener
                plugin._clickListen();
            },

            _moveNav: function() {
                var plugin = this,
                    navInContentPanel = false;
                plugin.$navPrev = [];
                plugin.$navParent = [];

                navInContentPanel = plugin.$nav.parents().find(plugin.$contentPanel).length > 0;

                if (navInContentPanel) {
                    // save the nav's current position so we can put it back on destroy
                    plugin.$navPrev = plugin.$nav.prev();
                    plugin.$navParent = plugin.$nav.parent();
                    // move the nav outside of the content panel
                    plugin.$nav.detach().insertBefore(plugin.$contentPanel);
                }

                if (typeof plugin.options.setupCallback === "function")
                    plugin.options.setupCallback();
            },

            _clickListen: function() {
                var plugin = this;

                plugin.$element.on('click.shamone', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var $this = $(this);

                    if (plugin.isOpen) {
                        //close panel
                        plugin.close(true, true);
                    } else {
                        // open panel
                        plugin.open();
                    }
                });
            },

            open: function() {
                // re-reference the plugin to avoid this conflicts
                var plugin = this,
                    $body = $('body'),
                    $fixedPanel = $(plugin.options.contentPanelSelector);

                // open panel - add css classes
                plugin.$target.addClass(plugin.options.activeNavSectionClass);
                plugin.$element.addClass(plugin.options.activeButtonClass);
                plugin.$contentPanel.addClass(plugin.options.classPrefix + plugin.options.slideDirection);

                // make sure that the body is tall enough and the user can't scroll past the nav
                $fixedPanel.css('position', 'fixed');
                plugin.$target.css('height', $(window).height() > plugin.$target.outerHeight() ? $(window).height() : plugin.$target.outerHeight());

                // add click handler to close if user clicks anywhere outside of the navigation
                $fixedPanel.on('click.shamone', function(event) {
                    plugin.close(true, true);
                });

                // add click handler to close nav if user clicks a nav link
                plugin.$target.on('click.shamone', function(event) {
                    event.stopPropagation();
                    if (event.target.tagName.toLowerCase() == "a")
                        plugin.close(false, false);
                });

                // set flag on plugin object
                plugin.isOpen = true;

                // hollaback!
                if (typeof plugin.options.openCallback === "function")
                    plugin.options.openCallback();

            },

            close: function(animateIt, fireCallback) {
                var plugin = this,
                    $fixedPanel = $(plugin.options.contentPanelSelector);

                // remove animation
                if (!animateIt) {
                    plugin.$element.removeClass(plugin.options.animateSlideClass);
                    plugin.$nav.removeClass(plugin.options.animateSlideClass);
                    plugin.$contentPanel.removeClass(plugin.options.animateSlideClass);
                }

                // clear out css classes
                plugin.$target.removeClass(plugin.options.activeNavSectionClass);
                plugin.$element.removeClass(plugin.options.activeButtonClass);
                plugin.$contentPanel.removeClass(plugin.options.classPrefix + plugin.options.slideDirection);

                // reset height
                //plugin.$target.css('height', 'auto');
                $fixedPanel.css('position', 'relative');

                // remove event handlers
                $fixedPanel.off('click.shamone');
                plugin.$target.off('click.shamone');

                // set flag on plugin object
                plugin.isOpen = false;

                // only fire callback if user tapped the close button or otherwise closed the nav
                // don't fire callback if panel closes because they clicked a link to another page
                if (fireCallback && typeof plugin.options.closeCallback === "function")
                    plugin.options.closeCallback();

            },

            destroy: function() {
                var plugin = this;

                // make sure nav is closed
                plugin.close(false);

                // remove height
                plugin.$target.css('height', 'auto');

                // remove all classes
                plugin.$element.removeClass(plugin.options.buttonClass + " " + plugin.options.animateSlideClass);
                plugin.$nav.removeClass(plugin.options.navClass + " " + plugin.options.animateSlideClass);
                plugin.$contentPanel.removeClass(plugin.options.contentPanelClass + " " + plugin.options.animateSlideClass);

                // remove listeners
                plugin.$element.off('click.shamone');

                // move nav back to where it was
                if (plugin.$navPrev.length > 0) {
                    plugin.$nav.detach().insertAfter(plugin.$navPrev);
                } else if (plugin.$navParent.length > 0) {
                    plugin.$nav.detach().prependTo(plugin.$navParent);
                }

                if (typeof plugin.options.destroyCallback === "function")
                    plugin.options.destroyCallback();

                // remove the data
                plugin.$element.removeData('plugin_' + pluginName);
            }
        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function(options) {
            return this.each(function() {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Shamone(this, options));
                }
            });
        }

    })(jQuery, window, document);
});
/*
Keep on slidin'
Hee hee!

___________§§§$$§§$§§_
_________$$$$$§§§$$§§$§_
_______($$$$$$$§§§$$§§$§§_(§§)_
_______($$$$$$$$$$$$§§$$__$§§$)~
________(§§§$$$$§$$$$§§$$§§$§§$§§~
________((_($$§§$§§$§§§§§§§§§$$§§$
________))_(§$$$$$$§§$$§§$§§$§§§§§~
_________((_)_((§$$§$$§§$$§§$§§$§§§§((....
___________))_)_§$$))_$$$§§§$$§§$§§$§§§§§
___________(__(_))_§$§§§§§$$§§$$§§$§§$§§§
_______________(__$_$$§§§§§§$$§§$$§§$§§$§§
_______________)_$_$§$§§§§§§$§§$$§§$§§§§__§
__________________)$__§§§§§§$§$$_§$$§§___§$§
_________________(§___$§§§§§$§§$_§$$___§§§§§§
_________________($§__$§$§§§$$$§§§_$__$§§§§§$§§
__________________§§§_§$$$$$§§§§§§§$§§_§$$§$$§§§§
___________________(§__§§§§§§§§§§$§§$$§§_§§$_§§§§§
___________________(§_$$§§$§§§§§§§§$$§§$§_$§§§§§§
____________________§_$§§$§§§§§§§§$$§§_§§$§§§§§§
____________________§__$$§§§§$§§§§§§$_§§$§§$§§§
_____________________§_$$§§§§$§§§§§__$§§$§§$§§
_____________________§_$$_§§§§§§$§§$$§§$§§§§
_____________________§§§§_§§§§§$§§$$§§$§§§§
_____________________§§§$$::::§§$$$§§$$§§$_§
___________________§§§§:§§§§§§__§§$§§$§_§§
_________________§$$:§§§§§$$$§___§$§§$§§§§
______________§§:§§$§$$§§$$__$§§$§§§§§§
____________$$§:§§§$§$$$$$§§$$§§$§§$§_§§§
__________$$§:§§$$$$$$§§$§§§§§§§$$___$§§
_______$$$§::§$$$$$$§§$§§§§§§§§§______§§
_____$$$§::§$$$$FL$§§§§§§§$§§$_________§
___$$$§::§§$$$$§§§§$$$§§§§
_$$§::§§§$$§§$§§§§§§§§§
$§§§$§§§§§$$§§§§§§§
§§§§§§§$$§§$§§§§
_§§§§§§§§$§§_§§$
_§§§§§§§§§$§§$_§§§
__§§§§$§§§$§$§§$_§§
___§§§§$§§§$§$§§$_§§
_____$§§§§§§§§§§§$§_§§
______§§§$§§§§§§$§§$§_§
_______$§§§§§§§$$§$$§§_§§
________§§§§$$§§$$§§$$§§_§
_________§$§$$$§§§§§§$$§§$§§
__________$$$$§§$_§§$§§$§§§§§§
___________§$§§$§§_§§§§§§§§§$$§§$§
____________§$§§$§§_§§§§§§§§_$$§§$
_____________§$§§$§§_$§§§§§__§§$§
_________________§$§§$______§§§§
__________________§§§§§_§§__§§§§$
__________________§§§$§§__$§§§§§§§
___________________§$§§$§____§$§§§§
_____________________§§§$§§___§§$§§
*/
;
